export default __webpack_public_path__ + "static/media/krakow.39b0ce77.jpg";